import React, { Component } from 'react';
import { Link } from 'react-router';

import Pagination from "../../components/Pagination";
import UserStore from "../../stores/UserStore";
import SessionStore from "../../stores/SessionStore";

class SearchBox extends Component {
  constructor() {
    super();

    this.state = {
      searchText: "",
    };
  }

  onTextChange (e) {
    let v = e.target.value

    this.setState({
      searchText: e.target.value,
    });

    if (this.props.onSearch) {
      this.props.onSearch(v);
    }
  }

  render () {
    return (
      <div>
        <label>
          <input type="text" placeholder="input key to search" value={this.state.searchText || ''} onChange={this.onTextChange.bind(this)} /> &nbsp;&nbsp;&nbsp;&nbsp;
        </label>
      </div>
    );
  }
}

class UserRow extends Component {
  render() {
    return(
      <tr>
        <td><Link to={`/users/${this.props.user.id}/edit`}>{this.props.user.username}</Link></td>
        <td className={(this.props.superUser.isAdmin && this.props.superUser.isActive) ? '' : 'hidden'}>{this.props.user.mqttUser}</td>
        <td className={(this.props.superUser.isAdmin && this.props.superUser.isActive) ? '' : 'hidden'}>{this.props.user.mqttPassword}</td>
        <td><span className={"glyphicon glyphicon-" + (this.props.user.isActive ? 'ok' : 'remove')} aria-hidden="true"></span></td>
        <td><span className={"glyphicon glyphicon-" + (this.props.user.isAdmin ? 'ok' : 'remove')} aria-hidden="true"></span></td>
      </tr>
    );
  }
}

class ListUsers extends Component {
  static contextTypes = {
    router: React.PropTypes.object.isRequired
  };

  constructor() {
    super();

    this.state = {
      users: [],
      user: SessionStore.getUser(),
      searchText: "",
      isSearch: false,
      pageSize: 20,
      pageNumber: 1,
      pages: 1,
    };

    this.updatePage = this.updatePage.bind(this);
  }

  componentDidMount() {
    this.updatePage(this.props);
  }

  componentWillReceiveProps(nextProps) {
    this.updatePage(nextProps);
  }

  updatePage(props) {
    let page = (props.location.query.page === undefined) ? 1 : props.location.query.page;

    if (this.state.isSearch) {
      page = 1
      this.setState({isSearch: false})
    }

    UserStore.getAll(this.state.searchText, this.state.pageSize, (page-1) * this.state.pageSize, (totalCount, users) => {
      this.setState({
        users: users,
        user: SessionStore.getUser(),
        pageNumber: page,
        pages: Math.ceil(totalCount / this.state.pageSize),
      });
      window.scrollTo(0, 0);
    });
  }

  onSearchCallback (text) {
    this.setState({
      pageNumber: 1,
      isSearch: true,
      searchText: text,
    }, () => {
      this.updatePage(this.props);
    });
  }

  render() {
    const UserRows = this.state.users.map((user, i) => <UserRow key={user.id} user={user} superUser={this.state.user} />);
    
    return(
      <div>
        <ol className="breadcrumb">
          <li className="active">Users</li>
        </ol>
        <div className="clearfix">
          <div className="pull-left">
              <SearchBox onSearch={this.onSearchCallback.bind(this)}></SearchBox>
            </div>
          <div className="btn-group pull-right" role="group" aria-label="...">
            <Link to="/users/create"><button type="button" className="btn btn-default">Create user</button></Link>
          </div>
        </div>
        <hr />
        <div className="panel panel-default">
          <div className="panel-body">
            <table className="table table-hover">
              <thead>
                <tr>
                  <th>Username</th>
                  <th className={(this.state.user.isAdmin && this.state.user.isActive) ? '' : 'hidden'}>MqttUser</th>
                  <th className={(this.state.user.isAdmin && this.state.user.isActive) ? '' : 'hidden'}>MqttPasswd</th>
                  <th className="col-md-1">Active</th>
                  <th className="col-md-1">Admin</th>
                </tr>
              </thead>
              <tbody>
                {UserRows}
              </tbody>
            </table>
          </div>
          <Pagination pages={this.state.pages} currentPage={this.state.pageNumber} pathname="/users" />
        </div>
      </div>
    );
  }
}

export default ListUsers;



// WEBPACK FOOTER //
// ./src/views/users/ListUsers.js